import React from 'react';
import {
  Box,
  Container,
  Button,
  Typography,
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  Login,
  PersonAdd,
  ArrowForward
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const GuestPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogin = () => {
    navigate('/login');
  };

  const handleSignup = () => {
    navigate('/signup');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0A2A66 0%, #1a3a76 100%)',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {/* Background Shape */}
      <Box
        sx={{
          position: 'absolute',
          top: 40,
          left: 16,
          width: 500,
          height: '60vw',
          maxHeight: 400,
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%',
          transform: 'rotate(-5deg)',
          zIndex: 1
        }}
      />

      <Container
        maxWidth="sm"
        sx={{
          position: 'relative',
          zIndex: 2,
          px: 2
        }}
      >
        <Paper
          elevation={24}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            textAlign: 'center'
          }}
        >
          {/* Welcome Icon */}
          <Box
            sx={{
              width: 120,
              height: 120,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #006AF9 0%, #0056CC 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 4,
              boxShadow: '0 8px 25px rgba(0, 106, 249, 0.3)'
            }}
          >
            <Typography
              variant="h2"
              sx={{
                color: 'white',
                fontWeight: 'bold',
                fontSize: '3rem'
              }}
            >
              👋
            </Typography>
          </Box>

          {/* Welcome Text */}
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 'bold',
              color: '#00040B',
              mb: 2,
              fontSize: { xs: '1.75rem', md: '2.25rem' }
            }}
          >
            Welcome to Our App!
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: '#666',
              mb: 4,
              fontSize: { xs: '1rem', md: '1.1rem' },
              lineHeight: 1.6
            }}
          >
            Discover amazing services and connect with the best providers in your area.
            Join our community today!
          </Typography>

          {/* Action Buttons */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={handleLogin}
              startIcon={<Login />}
              endIcon={<ArrowForward />}
              sx={{
                py: 1.5,
                borderRadius: 2,
                backgroundColor: '#006AF9',
                background: 'linear-gradient(135deg, #006AF9 0%, #0056CC 100%)',
                boxShadow: '0 4px 15px rgba(0, 106, 249, 0.3)',
                fontSize: '1.1rem',
                fontWeight: 600,
                textTransform: 'none',
                '&:hover': {
                  background: 'linear-gradient(135deg, #0056CC 0%, #004499 100%)',
                  boxShadow: '0 6px 20px rgba(0, 106, 249, 0.4)',
                },
              }}
            >
              Login to Your Account
            </Button>

            <Button
              fullWidth
              variant="outlined"
              onClick={handleSignup}
              startIcon={<PersonAdd />}
              endIcon={<ArrowForward />}
              sx={{
                py: 1.5,
                borderRadius: 2,
                borderColor: '#006AF9',
                borderWidth: 2,
                color: '#006AF9',
                fontSize: '1.1rem',
                fontWeight: 600,
                textTransform: 'none',
                '&:hover': {
                  borderColor: '#0056CC',
                  backgroundColor: 'rgba(0, 106, 249, 0.05)',
                  borderWidth: 2,
                },
              }}
            >
              Create New Account
            </Button>
          </Box>

          {/* Additional Info */}
          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #eee' }}>
            <Typography
              variant="body2"
              sx={{
                color: '#666',
                fontSize: '0.9rem'
              }}
            >
              By continuing, you agree to our Terms of Service and Privacy Policy
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default GuestPage; 